import { render, staticRenderFns } from "./IconPuppy.vue?vue&type=template&id=8ebf5604&"
import script from "./IconPuppy.vue?vue&type=script&lang=js&"
export * from "./IconPuppy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ebf5604')) {
      api.createRecord('8ebf5604', component.options)
    } else {
      api.reload('8ebf5604', component.options)
    }
    module.hot.accept("./IconPuppy.vue?vue&type=template&id=8ebf5604&", function () {
      api.rerender('8ebf5604', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconPuppy.vue"
export default component.exports